const getNihClinGenVariantsData = (state) => {
  return state.variantResult && state.variantResult.nih_clingen_variants;
};

export { getNihClinGenVariantsData };
